module.exports = __webpack_public_path__ + "img/guizhou.0ac3689c.png";